import React, { Component } from 'react';

import PropTypes from 'prop-types';
import autoBind from 'react-autobind';

import AutoComplete from 'ui/common/multi-auto-complete';

export class LocalMultiAutoCompleteField extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    returnAsObj: PropTypes.bool, // optional
    placeholder: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ).isRequired,
  };

  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      selectedOptions: props.input.value || null,
    };
  }

  handleChange(selected) {
    const {
      input, // redux-form
      returnAsObj, // bool that return arrayOf object
      apiResponseConfig: { valueKey }, // determine the returning value
    } = this.props;

    this.setState({
      selectedOptions: selected,
    });

    if (selected && returnAsObj) {
      input.onChange(selected);
    } else if (selected) {
      const selectedArray = selected.map(entry => {
        return valueKey && entry[valueKey] ? entry[valueKey] : entry;
      });
      input.onChange(selectedArray);
    } else {
      input.onChange([]);
    }
  }

  render() {
    const { input, meta, label, options, placeholder, ...passThrough } = this.props;
    const { form, touched, error } = meta;
    const {
      selectedOptions, // list of skill to select
    } = this.state;
    const inputId = `${form}-${input.name}`;

    return (
      <div id={inputId}>
        {label && <div className="pb-3 font-weight-bold">{label}</div>}
        <AutoComplete
          defaultValue={input.value}
          options={options} // specify the options the user can select from
          value={selectedOptions} //control the current value
          placeholder={placeholder}
          onChange={this.handleChange}
          {...passThrough}
        />
        {touched && error && <span className="d-block text-danger pt-1">{error}</span>}
      </div>
    );
  }
}

export default LocalMultiAutoCompleteField;



// WEBPACK FOOTER //
// ./src/ui/common/form/fields/local-multi-auto-complete-field.js